var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useAuthenticationForm } from '../../validations';
import { useSignUpMutation } from '../../hooks/api/authentication/useSignUp.api';
import { useSignInMutation } from '../../hooks/api/authentication/useSignIn.api';
import { CognitoError, } from '../../models';
import { useErrorHandler, useStorage } from '../../contexts';
import { useCheckCustomerServerApi } from '../../hooks';
import { useLanguage } from '../../locale';
import { GeneralActions, detectedCountryCodeSelector, getUserTimeZone, } from '../../redux';
import { StorageKeys } from '../../services';
import { getRegionByCountryCode } from '../../utils/region.utils';
import { MULTITENANT_ENABLED } from '../../utils/featureFlags';
export var useEmailInputFacade = function (_a) {
    var _b;
    var onNext = _a.onNext, isDev = _a.isDev;
    var blockInteraction = useErrorHandler().blockInteraction;
    var storage = useStorage();
    var dispatch = useDispatch();
    var _c = useAuthenticationForm(), handleSubmit = _c.handleSubmit, emailValue = _c.emailValue, onEmailChange = _c.onEmailChange, errors = _c.errors;
    var _d = useLanguage(), currentLocale = _d[2];
    var detectedCountryCode = useSelector(detectedCountryCodeSelector);
    var userTimezone = useSelector(getUserTimeZone);
    var _f = useState(null), pendingAfterAutoRegion = _f[0], setPendingAfterAutoRegion = _f[1];
    // ** API ** //
    var signUpApi = useSignUpMutation().mutateAsync;
    var signInApi = useSignInMutation().mutateAsync;
    var checkCustomerServerApi = useCheckCustomerServerApi({
        isDev: isDev,
    }).mutateAsync;
    // ** CALLBACKS ** //
    var signUp = useCallback(function (email) { return __awaiter(void 0, void 0, void 0, function () {
        var username, locale;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    username = email;
                    locale = currentLocale === 'it' ? 'IT' : 'EN';
                    return [4 /*yield*/, signUpApi({ email: email, username: username, locale: locale })];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    }); }, [signUpApi, currentLocale]);
    var signIn = useCallback(function (email) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, signInApi({ email: email })];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    }); }, [signInApi]);
    var onPressIcon = useCallback(function () {
        onEmailChange('');
    }, [onEmailChange]);
    // Run signUp -> signIn -> onNext(POST_SIGN_IN) after repo context has switched to targetRegion
    useEffect(function () {
        if (!pendingAfterAutoRegion ||
            userTimezone !== pendingAfterAutoRegion.targetRegion) {
            return;
        }
        var email = pendingAfterAutoRegion.email;
        setPendingAfterAutoRegion(null);
        var run = function () { return __awaiter(void 0, void 0, void 0, function () {
            var isUserRegistered, error_1, err, res, e_1;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        isUserRegistered = false;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, signUp(email)];
                    case 2:
                        _b.sent();
                        isUserRegistered = true;
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _b.sent();
                        err = error_1;
                        if (((_a = err === null || err === void 0 ? void 0 : err.data) === null || _a === void 0 ? void 0 : _a.__type) !== CognitoError.UsernameExists) {
                            blockInteraction('Something went wrong while signing up');
                            return [2 /*return*/];
                        }
                        isUserRegistered = true;
                        return [3 /*break*/, 4];
                    case 4:
                        if (!isUserRegistered)
                            return [2 /*return*/];
                        _b.label = 5;
                    case 5:
                        _b.trys.push([5, 8, , 9]);
                        return [4 /*yield*/, signIn(email)];
                    case 6:
                        res = _b.sent();
                        return [4 /*yield*/, onNext({
                                type: 'POST_SIGN_IN',
                                email: email,
                                session: res.Session,
                            })];
                    case 7:
                        _b.sent();
                        return [3 /*break*/, 9];
                    case 8:
                        e_1 = _b.sent();
                        console.error('Error signing in:', e_1);
                        blockInteraction('Something went wrong while signing in');
                        return [3 /*break*/, 9];
                    case 9: return [2 /*return*/];
                }
            });
        }); };
        void run();
    }, [
        blockInteraction,
        onNext,
        pendingAfterAutoRegion,
        signIn,
        signUp,
        userTimezone,
    ]);
    // ** DATA ** //
    var signUpAndIn = useMemo(function () {
        return handleSubmit(function (data) { return __awaiter(void 0, void 0, void 0, function () {
            var isUserRegistered, userTimeZone, targetRegion, _e_1, targetRegion, _e_2, error_2, err, res, navigationParams, e_2;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        isUserRegistered = false;
                        if (!MULTITENANT_ENABLED) return [3 /*break*/, 8];
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 5, , 7]);
                        return [4 /*yield*/, checkCustomerServerApi(data.email)];
                    case 2:
                        userTimeZone = _b.sent();
                        if (!!(userTimeZone === null || userTimeZone === void 0 ? void 0 : userTimeZone.tenant)) return [3 /*break*/, 4];
                        targetRegion = getRegionByCountryCode(detectedCountryCode !== null && detectedCountryCode !== void 0 ? detectedCountryCode : '');
                        dispatch(GeneralActions.setUserTimezone(targetRegion));
                        return [4 /*yield*/, storage.setItem(StorageKeys.USER_TIME_ZONE, targetRegion)];
                    case 3:
                        _b.sent();
                        setPendingAfterAutoRegion({ email: data.email, targetRegion: targetRegion });
                        return [2 /*return*/];
                    case 4: return [3 /*break*/, 7];
                    case 5:
                        _e_1 = _b.sent();
                        targetRegion = getRegionByCountryCode(detectedCountryCode !== null && detectedCountryCode !== void 0 ? detectedCountryCode : '');
                        dispatch(GeneralActions.setUserTimezone(targetRegion));
                        return [4 /*yield*/, storage.setItem(StorageKeys.USER_TIME_ZONE, targetRegion)];
                    case 6:
                        _b.sent();
                        setPendingAfterAutoRegion({ email: data.email, targetRegion: targetRegion });
                        return [2 /*return*/];
                    case 7: return [3 /*break*/, 11];
                    case 8:
                        _b.trys.push([8, 10, , 11]);
                        return [4 /*yield*/, checkCustomerServerApi(data.email)];
                    case 9:
                        _b.sent();
                        return [3 /*break*/, 11];
                    case 10:
                        _e_2 = _b.sent();
                        return [3 /*break*/, 11];
                    case 11:
                        _b.trys.push([11, 13, , 14]);
                        return [4 /*yield*/, signUp(data.email)];
                    case 12:
                        _b.sent();
                        isUserRegistered = true;
                        return [3 /*break*/, 14];
                    case 13:
                        error_2 = _b.sent();
                        err = error_2;
                        if (((_a = err === null || err === void 0 ? void 0 : err.data) === null || _a === void 0 ? void 0 : _a.__type) !== CognitoError.UsernameExists) {
                            blockInteraction('Something went wrong while signing up');
                            return [2 /*return*/];
                        }
                        isUserRegistered = true;
                        return [3 /*break*/, 14];
                    case 14:
                        if (!isUserRegistered)
                            return [2 /*return*/, undefined];
                        _b.label = 15;
                    case 15:
                        _b.trys.push([15, 18, , 19]);
                        return [4 /*yield*/, signIn(data.email)];
                    case 16:
                        res = _b.sent();
                        navigationParams = {
                            type: 'POST_SIGN_IN',
                            email: data.email,
                            session: res.Session,
                        };
                        return [4 /*yield*/, onNext(navigationParams)];
                    case 17:
                        _b.sent();
                        return [3 /*break*/, 19];
                    case 18:
                        e_2 = _b.sent();
                        console.error('Error signing in:', e_2);
                        blockInteraction('Something went wrong while signing in');
                        return [3 /*break*/, 19];
                    case 19: return [2 /*return*/];
                }
            });
        }); });
    }, [
        blockInteraction,
        checkCustomerServerApi,
        detectedCountryCode,
        dispatch,
        handleSubmit,
        onNext,
        signIn,
        signUp,
        storage,
    ]);
    return {
        value: emailValue,
        onChangeText: onEmailChange,
        onPressIcon: onPressIcon,
        error: (_b = errors.email) === null || _b === void 0 ? void 0 : _b.message,
        signUpAndIn: signUpAndIn,
    };
};
